import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { MAX_VISIBLE_BUTTONS_DESKTOP, MAX_VISIBLE_BUTTONS_MOBILE } from '../../constants/pagination';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import UsageTracker from '../../../../utils/UsageTracker';
import { Flex } from 'foundations-components/components/Flex';
import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
const getPageSizeOptions = totalResults => {
  return PAGE_SIZE_OPTIONS.filter(size => size <= totalResults || size === PAGE_SIZE_OPTIONS[0]).map(size => ({
    text: I18n.text('learningCenter.myTeam.pagination.itemsPerPage', {
      pageSize: size
    }),
    value: size
  }));
};
const MyTeamTablePagination = ({
  totalResults,
  page,
  pageSize,
  hasPinnedRow = false,
  onPageChange,
  onPageSizeChange
}) => {
  const {
    isNotMobile
  } = useMediaQuery();
  const handlePageChange = event => {
    const newPage = event.target.value;
    if (newPage !== page) {
      UsageTracker.track('teamInteraction', {
        action: 'change-table-page',
        value: newPage
      });
      onPageChange(newPage);
    }
  };
  const handlePageSizeChange = event => {
    const selectedValue = event.target.value;
    if (selectedValue !== null && onPageSizeChange) {
      UsageTracker.track('teamInteraction', {
        action: 'change-table-page-size',
        value: selectedValue
      });
      onPageSizeChange(selectedValue);
    }
  };
  const availablePageSizeOptions = getPageSizeOptions(totalResults);
  const pageCount = hasPinnedRow ? Math.ceil(totalResults / (pageSize - 1)) : Math.ceil(totalResults / pageSize);
  return pageCount > 1 && /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    justifyContent: "center",
    children: [/*#__PURE__*/_jsx(Paginator, {
      maxVisiblePageButtons: isNotMobile ? MAX_VISIBLE_BUTTONS_DESKTOP : MAX_VISIBLE_BUTTONS_MOBILE,
      onPageChange: handlePageChange,
      page: page,
      pageCount: pageCount,
      showFirstLastButtons: true
    }), isNotMobile && /*#__PURE__*/_jsx(Select, {
      anchorType: "button",
      "aria-label": I18n.text('learningCenter.myTeam.pagination.label'),
      buttonUse: "transparent",
      onChange: handlePageSizeChange,
      options: availablePageSizeOptions,
      value: pageSize
    })]
  });
};
export default MyTeamTablePagination;